<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78"><path class="sell-tag-a" d="M0,0H78V78H0Z"/><path class="sell-tag-b" d="M34.807,64.233a6.39,6.39,0,0,1-4.547-1.882L1.893,33.986A6.353,6.353,0,0,1,0,29.455V6.427A6.434,6.434,0,0,1,6.424,0H29.46a6.423,6.423,0,0,1,4.525,1.866L62.351,30.231a6.409,6.409,0,0,1,.036,9.092L39.35,62.351A6.378,6.378,0,0,1,34.807,64.233Zm6.574-29.187a4.354,4.354,0,1,0,3.084,1.278A4.21,4.21,0,0,0,41.381,35.047ZM40.19,26.332a.676.676,0,0,0-.575.294L27.628,42.6a.731.731,0,0,0-.148.428.738.738,0,0,0,.728.727h1.817a.676.676,0,0,0,.575-.294L42.587,27.487a.741.741,0,0,0,.148-.433.7.7,0,0,0-.219-.509.688.688,0,0,0-.509-.213Zm-11.356,0a4.363,4.363,0,1,0,3.079,1.278A4.2,4.2,0,0,0,28.834,26.332ZM14.455,9.641a4.818,4.818,0,1,0,4.82,4.814A4.821,4.821,0,0,0,14.455,9.641Z" transform="translate(6.876 6.875)"/></svg>
</template>

<script>
	export default {
		name: 'sell-tag'
	}
</script>

<style>
	.sell-tag-a {
		fill:none;
	}
	.sell-tag-b {
		fill:#82be00;
	}

	.v-icon__component {
		width: auto !important;
		height: auto !important;
	}
</style>